import {
  faBuilding,
  faChartSimple,
  faCircleInfo, faClipboardList,
  faContactBook,
  faDatabase,
  faFileInvoice,
  faGear, faHeart,
  faHouseChimneyMedical,
  faLineChart,
  faRobot,
  faSquareRss,
  faUsersGear
} from "@fortawesome/free-solid-svg-icons";

export const platformMenuItems = [
  {
    name: "儀表板",
    isDivider: false,
    path: "/admin/dashboard",
    icon: faChartSimple,
    role: ['god']
  },
  {
    name: "業務組別管理",
    isDivider: false,
    path: "/admin/organizationManagement",
    icon: faBuilding,
    role: ['admin', 'god']
  },
  {
    name: "帳號管理",
    isDivider: false,
    path: "/admin/userManagement",
    icon: faUsersGear,
    role: ['admin', 'god']
  },
  {
    name: "案件管理",
    isDivider: false,
    path: "/admin/caseManagement",
    icon: faFileInvoice,
    role: ['admin', 'worker', 'god']
  },
]

export const lineOaMenuItems = [
  {
    name: "就醫資訊管理",
    isDivider: false,
    path: "/admin/medicalOrganizationManagement",
    icon: faHouseChimneyMedical,
    permissions: ['medicalOrganizationManagement'],
  },
  {
    name: "衛教資訊管理",
    isDivider: false,
    path: "/admin/contentManagement",
    icon: faSquareRss,
    permissions: ['contentManagement'],
  },
  {
    name: "聊天機器人",
    isDivider: false,
    path: "/admin/robotManagement",
    icon: faRobot,
    permissions: ['robotManagement'],
  },
  {
    name: "生理量測系統",
    isDivider: false,
    path: "/admin/measurementManagement",
    icon: faLineChart,
    permissions: ['measurementManagement']
  },
  {
    name: "BSRS系統",
    isDivider: false,
    path: "/admin/bsrs",
    icon: faHeart,
    permissions: ['bsrs']
  },
  {
    name: "備份管理",
    isDivider: false,
    path: "/admin/databaseManagement",
    icon: faDatabase,
    permissions: ['databaseManagement']
  },
  {
    name: "業務窗口資訊",
    isDivider: false,
    path: "/admin/contact",
    icon: faContactBook,
    permissions: ['contact']
  },
  {
    name: "系統資訊",
    isDivider: false,
    path: "/admin/systemInfo",
    icon: faCircleInfo,
    permissions: ['systemInfo']
  },
  {
    name: "開發者專區",
    isDivider: false,
    path: "/admin/storyBoard",
    icon: faGear,
    permissions: ['storyBoard']
  },
  {
    name: "系統編輯紀錄",
    isDivider: false,
    path: "/admin/auditLog",
    icon: faClipboardList,
    permissions: ['auditLog']
  },
];
